
@switch (columnId) {
  @case (OrganizationOrderBy.Id) {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case (OrganizationOrderBy.Name) {
    <lib-text-table-column>
      {{ element.name }}
    </lib-text-table-column>
  }
  @case ('contact') {
    <lib-text-table-column>
      {{ getDisplayTextForContactEmail() }}
    </lib-text-table-column>
  }
  @case ('address') {
    <lib-text-table-column>
      {{ getDisplayTextForAddress() }}
    </lib-text-table-column>
  }
  @case (OrganizationOrderBy.Solution) {
    <lib-text-table-column>
      {{ getDisplayTextForSolution() }}
    </lib-text-table-column>
  }
  @case ('isMerchant') {
    <lib-binary-status-icon
      [value]="element?.isMerchant"
      [showPositiveOnly]="true">
    </lib-binary-status-icon>
    <lib-table-column-sort [key]="element?.isMerchant ? 1 : 0"></lib-table-column-sort>
  }
  @default {
  }
}





